// =======================
// src/estilos/paginacao.js
// =======================

import { tamanhosControlesGlobais } from "./global";

export const containerPaginacao = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 0.25,
  flexShrink: 0,
};

export const botaoNavegacaoPaginacao = {
  minWidth: "auto",
  height: 32,
  px: 1.1,
  borderRadius: 1,

  color: "var(--sear-texto-secundario, #506784)",

  fontSize: tamanhosControlesGlobais.paginacao,
  fontWeight: 500,
  textTransform: "none",

  "&:hover": {
    color: "var(--sear-azul, #0767d8)",
    backgroundColor: "var(--sear-superficie-azul, #edf5fc)",
  },

  "&.Mui-disabled": {
    color: "var(--sear-texto-suave, #a9b7c5)",
  },

  "& .MuiButton-startIcon": {
    mr: 0.35,
  },

  "& .MuiButton-endIcon": {
    ml: 0.35,
  },
};

export const botaoProximaPaginacao = {
  ...botaoNavegacaoPaginacao,

  color: "var(--sear-azul, #0767d8)",

  fontWeight: 600,

  "&:hover": {
    color: "var(--sear-azul, #0767d8)",
    backgroundColor: "var(--sear-superficie-azul, #eaf4ff)",
  },

  "&.Mui-disabled": {
    color: "var(--sear-texto-suave, #a9b7c5)",
  },
};

export const botaoNumeroPaginacao = {
  minWidth: 32,
  width: 32,
  height: 32,
  p: 0,

  borderRadius: 1,

  color: "var(--sear-azul, #315d8e)",
  backgroundColor: "transparent",

  fontSize: tamanhosControlesGlobais.paginacao,
  fontWeight: 500,
  textTransform: "none",

  boxShadow: "none",

  "&:hover": {
    color: "var(--sear-azul, #0767d8)",
    backgroundColor: "var(--sear-superficie-azul, #eaf4ff)",
    boxShadow: "none",
  },
};

export const botaoNumeroPaginacaoAtivo = {
  ...botaoNumeroPaginacao,

  color: "#ffffff",
  backgroundColor: "var(--sear-acao-azul, #1976d2)",

  fontWeight: 700,

  boxShadow: "0 1px 3px rgba(25, 118, 210, 0.18)",

  "&:hover": {
    color: "#ffffff",
    backgroundColor: "var(--sear-acao-azul-hover, #1565c0)",

    boxShadow: "0 1px 3px rgba(25, 118, 210, 0.18)",
  },
};

export const reticenciasPaginacao = {
  minWidth: 27,
  height: 32,

  display: "grid",
  placeItems: "center",

  color: "var(--sear-texto-secundario, #7b8ea5)",

  fontSize: tamanhosControlesGlobais.reticencias,

  userSelect: "none",
};

export const separadorPaginacao = {
  display: "flex",
  alignItems: "center",

  pl: 1.25,

  borderLeft: "1px solid var(--sear-borda, #d5e2ee)",
};
